


























































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'product-reviews',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop() private readonly productName: string;
  @Prop() private readonly productId: number;
  @Prop() private readonly reviews: Array<object>;
  @Prop() private readonly showReviewForm: boolean;

  private modalVisible: boolean = false;
  private showMoreReviews: boolean = false;

  private showModal(): void {
    document.body.classList.add('no-scroll');
    this.modalVisible = true;
  }

  private closeModal(): void {
    document.body.classList.remove('no-scroll');
    this.modalVisible = false;
  }

  private get reviewLimit(): number {
    return this.$mobileDetect.mobile() ? 2 : 10;
  }
}
